import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type WorkflowRunGenerationLaunchFailedAction = {
	type: 'WORKFLOW_RUN_GENERATION_LAUNCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): WorkflowRunGenerationLaunchFailedAction => ({
	type: 'WORKFLOW_RUN_GENERATION_LAUNCH_FAILED',
	payload,
});
